<div class="{{ tileClass + ' ' + activeShadow }}">
    <mat-icon
        id="{{ tileIconClass }}"
        fontSet="{{ fontSet }}"
        fontIcon="{{ fontIcon }}"
        aria-hidden="true"
        [hidden]="hideTitleIcon"
    >
    </mat-icon>
    <div class="text-area">
        <div class="tile-label">{{ tileName }}</div>
        <div class="tile-description" *ngIf="description != ''">
            {{ description }}
        </div>
    </div>
    <div [hidden]="hideEditIcon">
        <mat-icon
            id="herarchy-tile-edit-icon"
            fontSet="fas"
            fontIcon="fa-pencil-alt"
            aria-hidden="true"
            (click)="editIconClick()"
        >
        </mat-icon>
    </div>
</div>
